import { createStore } from 'vuex'
import auth from './modules/auth'
import afiliados from './modules/afiliados'
import federaciones from './modules/federaciones'
import organizaciones from './modules/organizaciones'
import territoriales from './modules/territoriales'
import empresas from './modules/empresas'
import configuraciones from './modules/configuraciones'
import funcionesSindicales from './modules/funcionesSindicales'
import centrosTrabajo from './modules/centrosTrabajo'
import factorias from './modules/factorias'
import tiposCobroCuota from './modules/tiposCobroCuota'
import usuarios from './modules/usuarios'

export default createStore({
  state: {
    sidebarVisible: true,
    sidebarUnfoldable: false,
    loading: false,
    toast: {
      show: false,
      message: '',
      color: 'primary',
      timeout: 3000
    }
  },
  getters: {
    sidebarVisible: state => state.sidebarVisible,
    sidebarUnfoldable: state => state.sidebarUnfoldable,
    loading: state => state.loading,
    toast: state => state.toast
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    setLoading(state, value) {
      state.loading = value
    },
    showToast(state, { message, color = 'primary', timeout = 3000 }) {
      state.toast = {
        show: true,
        message,
        color,
        timeout
      }
    },
    hideToast(state) {
      state.toast.show = false
    }
  },
  actions: {
    toggleSidebar({ commit }) {
      commit('toggleSidebar')
    },
    toggleUnfoldable({ commit }) {
      commit('toggleUnfoldable')
    },
    updateSidebarVisible({ commit }, payload) {
      commit('updateSidebarVisible', payload)
    },
    setLoading({ commit }, value) {
      commit('setLoading', value)
    },
    showToast({ commit }, payload) {
      console.log('showToast called with:', payload)
      commit('showToast', payload)
      
      // Ocultar el toast después del tiempo especificado
      setTimeout(() => {
        commit('hideToast')
      }, payload.timeout || 3000)
    }
  },
  modules: {
    auth,
    afiliados,
    federaciones,
    organizaciones,
    territoriales,
    empresas,
    configuraciones,
    funcionesSindicales,
    centrosTrabajo,
    factorias,
    tiposCobroCuota,
    usuarios
  }
})